import '../styles/app.scss';

/** Autoload */
import './autoload/_vanilla-jq';
import './autoload/_bootstrap';
import './autoload/_fonts';
import fetchInject from 'fetch-inject';
/* import formToObject from 'form_to_object'; */
import { debounce } from 'tiny-throttle';

/* Global vars */
window.debounce = debounce;

/** Util */
import './util/current-breakpoint';
import './util/root';
import './util/body-top-padding';
import './util/scrollbar-width';
import './util/bootstrap-container-width';
import './util/app-height';
import './util/splide-resize-height-of-slider';
import './util/fade-in-up-animation-on-intersection';
import './util/url-updater';
import './util/cards-mutation-observer';
import './util/event-news-resource-team-member-card-placeholder-images';
import './util/custom-scroll-to-element';

/** Sections */
import './sections/header';
import './sections/header-digital-experience';

/** Partials */
import './partials/search-form';
import './partials/shop-donate-dropdown';

/** Global */
import './global/global';

/** Components */
import './components/splide-slider';
import './components/dropdown';
import './components/custom-checkbox-radio';
import './components/card';
import './components/url-updater';
import './components/open-video-on-modal';
import './components/parallax-scene';
import './components/vertical-parallax-scene';
import './components/team-cards-container';
import './components/team-card-modal';
import './components/video-play-pause-on-visible';
import './components/card-grid-filters';
import './components/cards-container';
import './components/embedded-video-thumbnail';
import './components/button-group';
import './components/share-buttons';
import './components/single-product';
import './components/product-archive-filters';
import './components/header-cart-wishlist';
import './components/cart';
import './components/wishlist-page';
import './components/table';
import './components/donation-form';
import './components/digital-experience';
import './components/digital-experience-modal';

/** Templates */
import './templates/search';

/** Blocks */
import './blocks/quote';
import './blocks/card-grid-with-filters';
import './blocks/episode-playlist';
import './blocks/full-width-cta-card';

/** Make variables globals */
window.fetchInject = fetchInject;
